export default __webpack_public_path__ + "static/media/my-rewards-placeholder.7f2237b8.svg";